const { wrapPageElement } = require("./src/layouts");

// Wraps every page in a component
exports.wrapPageElement = wrapPageElement;
